module.exports = __webpack_public_path__ + "static/media/m_sf_5.3d87dc0c.png";